export const ENV_NAME = 'production';
export const DISABLE_ANALYTICS = false;
export const BASE_URL = 'https://api.getoutpatient.com/';
export const BASE_WS_URL = 'wss://ws-web.getoutpatient.com';
export const CLOUD_PROVIDER = 'aws'; // aws | azure
export const S3_PUBLIC_BUCKET_URL =
  'https://duploservices-prod01-outpatient-public-310481355385.s3.us-gov-east-1.amazonaws.com/';
export const TURNSTYLE_SITE_KEY = '0x4AAAAAAAGsjGUOHXrCSjSh';
export const USE_OKTA = false;
